/**
 * CalibrationChecklist - the ASTM C1074 checks on a calibration, one line each.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  CheckCircle as OkIcon,
  Warning as WarnIcon,
  Cancel as FailIcon,
  RemoveCircleOutline as NaIcon,
} from '@mui/icons-material';
import type { CalibrationCheck } from '../../services/calibrations';

const ICONS = {
  ok: <OkIcon fontSize="small" color="success" />,
  warn: <WarnIcon fontSize="small" color="warning" />,
  fail: <FailIcon fontSize="small" color="error" />,
  na: <NaIcon fontSize="small" color="disabled" />,
};

interface Props {
  checks: CalibrationCheck[];
  dense?: boolean;
}

const CalibrationChecklist: React.FC<Props> = ({ checks, dense }) => (
  <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }} aria-label="ASTM C1074 checks">
    {checks.map((c) => (
      <Box component="li" key={c.rule} sx={{ display: 'flex', gap: 1, py: dense ? 0.5 : 0.75 }}>
        <Box sx={{ pt: '1px' }}>{ICONS[c.status] ?? ICONS.na}</Box>
        <Box>
          <Typography variant="body2" fontWeight={c.status === 'ok' || c.status === 'na' ? 400 : 600}>
            {c.title}
            <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
              ASTM C1074 {c.clause}
            </Typography>
          </Typography>
          {c.detail && (
            <Typography variant="caption" color="text.secondary" display="block">
              {c.detail}
            </Typography>
          )}
        </Box>
      </Box>
    ))}
  </Box>
);

export default CalibrationChecklist;
